import api from "@/services/Api";

export default {
  async login({ commit }, credenciais) {
    try {
      const { data } = await api.post("/login", credenciais);

      if (!data.status) {
        return data;
      }
      const { token, permissions } = data;

      commit("SET_USER", data);
      commit("SET_TOKEN", token);
      commit("SET_PERMISSIONS", permissions);

      return data;
    } catch (e) {
      return { status: false };
    }
  },

  onLogout({ commit }) {
    commit("LOGOUT");
  },

  async insertUser({}, user) {
    try {
      await api.post("/users", user);
      return true;
    } catch (e) {
      return false;
    }
  },

  async listUsers({}, params) {
    try {
      const { data } = await api.get("/users", { params });
      return data;
    } catch (e) {
      return false;
    }
  },

  async showUser({}, id) {
    try {
      const { data } = await api.get("/users/" + id);
      return data;
    } catch (e) {
      return false;
    }
  },

  async updateUser({}, user) {
    try {
      await api.put("/users/" + user.id, user);
      return true;
    } catch (e) {
      return false;
    }
  },

  async deleteUser({}, id) {
    try {
      await api.delete("/users/" + id);
      return true;
    } catch (e) {
      return false;
    }
  },

  async storeListConfig({}, { data, slug }) {
    try {
      await api.post("/users/config/lists/" + slug, data);
      return true;
    } catch (e) {
      return false;
    }
  },

  async indexListConfig({}, slug) {
    try {
      const { data } = await api.get("/users/config/lists/" + slug);
      return data;
    } catch (e) {
      return false;
    }
  },

  async showAllPermissions({}) {
    try {
      const { data } = await api.get("/permissions");
      return data;
    } catch (e) {
      return false;
    }
  },
};
